export default __webpack_public_path__ + "static/media/Anvesana.f8b8d679.jpeg";